import AxiosWrapper from "../../basecomp/base/AxiosWrapper";
import { postData, putData } from "../apis/apis";


const AssignApi = async (data)=>{
    // alert(data)
    console.log("in api");
    console.log(data);
    
    // let response = await AxiosWrapper.axiosPostCallWithToken("/ticket-tool/assignticket",data)
    try{
    let response = await postData("/assignticket",data)

    console.log(response);
    return response
    }
    catch(error){
        throw error;
    }
}

export default AssignApi